const normalizeAmount = (value: unknown): number => {
  const normalizedValue =
    typeof value === "string" ? value.replace(/[$,\s]/g, "") : value;
  const numericValue = Number(normalizedValue);

  return Number.isFinite(numericValue) ? numericValue : 0;
};

export const hasValidPaymentPrincipal = (amount: unknown): boolean =>
  normalizeAmount(amount) > 0;

export const getPaymentTotalWithFee = (
  amount: unknown,
  convenienceFee: unknown
): number => {
  const principal = normalizeAmount(amount);
  if (principal <= 0) return 0;

  const fee = normalizeAmount(convenienceFee);
  return principal + Math.max(fee, 0);
};

export const getScheduledPaymentFailureTotal = (
  plannedAmount: unknown,
  plannedFee: unknown,
  orderAmount?: unknown,
  orderFee?: unknown
): number => {
  const normalizedOrderAmount = normalizeAmount(orderAmount);

  if (normalizedOrderAmount > 0) {
    return getPaymentTotalWithFee(normalizedOrderAmount, orderFee);
  }

  return getPaymentTotalWithFee(plannedAmount, plannedFee);
};
